<p-card styleClass="mailbox-card p-card-content-no-padding  p-card-body-pt-0 p-card-body-pb-0">

  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      <i class="pi pi-inbox mailbox-title-icon"></i>

      <div class="min-w-0">
        <div class="p-card-title">{{account?.name || 'Buzón'}}</div>
        <small class="text-color-secondary" *ngIf="accountAddress">{{accountAddress}}</small>
      </div>
      <div class="flex-grow-1"></div>
      <p-button icon="pi pi-refresh" label="Actualizar" [outlined]="true" severity="secondary"
                [loading]="foldersLoading || listLoading" (click)="refresh()"></p-button>
    </div>
  </ng-template>

  <div class="mailbox-layout">

    <!-- carpetas -->
    <aside class="mailbox-panel mailbox-folders">
      <div class="panel-head">
        <p-button icon="pi pi-pencil" label="Redactar" styleClass="w-full"
                  [disabled]="!allowSend" (click)="composeNew()"></p-button>
      </div>

      <div class="panel-body">
        <p-messages *ngIf="folderError" severity="error" [closable]="false">
          <ng-template pTemplate>
            <div class="flex flex-column gap-2">
              <span>{{folderError.message}}</span>
              <p-button *ngIf="folderError.retryable" label="Reintentar" icon="pi pi-refresh"
                        size="small" [text]="true" (click)="loadFolders()"></p-button>
            </div>
          </ng-template>
        </p-messages>

        <app-folder-tree *ngIf="!folderError"
                         [folders]="folders"
                         [selectedPath]="folderPath"
                         [mailAccountId]="mailAccountId"
                         [loading]="foldersLoading"
                         (folderSelected)="onFolderSelected($event)"></app-folder-tree>
      </div>

      <!-- al final de la columna: el arbol muestra solo las carpetas suscritas, y desde aqui se elige cuales -->
      <div class="panel-foot">
        <p-button icon="pi pi-cog" label="Administrar" size="small" [text]="true" severity="secondary"
                  styleClass="w-full"
                  pTooltip="Elegir qué carpetas se ven en el buzón"
                  (click)="openFoldersManager()"></p-button>
      </div>
    </aside>

    <!-- listado -->
    <section class="mailbox-panel mailbox-list">
      <div class="panel-head flex flex-column gap-2">
        <!-- input-field es la clase del proyecto (assets/css/forms.css) que da a los campos el tamaño del resto de
             la aplicacion: sin ella heredan el del tema, que es mas grande -->
        <div class="p-inputgroup input-field">
          <input pInputText [(ngModel)]="searchText" (keydown.enter)="applySearch()"
                 placeholder="Buscar en esta carpeta" />
          <p-button icon="pi pi-search" (click)="applySearch()"></p-button>
          <p-button *ngIf="hasSearch" icon="pi pi-times" severity="secondary" (click)="clearSearch()"></p-button>
        </div>

        <div class="flex gap-1 flex-wrap">
          <p-button label="Sin leer" size="small" [text]="!search.unseenOnly" [outlined]="search.unseenOnly"
                    severity="secondary" (click)="toggleSearchFilter('unseen')"></p-button>
          <p-button label="Destacados" size="small" [text]="!search.flaggedOnly" [outlined]="search.flaggedOnly"
                    severity="secondary" (click)="toggleSearchFilter('flagged')"></p-button>
          <!-- buscar en el cuerpo recorre el buzon entero si el servidor no tiene indice de texto completo, asi
               que se pide de forma explicita y no va activado por defecto -->
          <p-button label="En el texto" size="small" [text]="!search.searchBody" [outlined]="search.searchBody"
                    severity="secondary" pTooltip="Buscar también dentro del mensaje. Puede tardar bastante en buzones grandes."
                    (click)="toggleSearchFilter('body')"></p-button>
          <!-- la agrupacion es de lo que trae la pagina; al desplegar una conversacion se le pide al servidor el
               resto de sus mensajes, porque ningun servidor de los que usamos anuncia la extension THREAD -->
          <p-button *ngIf="conversationsEnabled"
                    label="Conversaciones" size="small" [text]="!grouped" [outlined]="grouped"
                    severity="secondary" pTooltip="Agrupar los mensajes por conversación"
                    (click)="toggleGrouped()"></p-button>
        </div>
      </div>

      <div class="panel-body">
        <p-messages *ngIf="listError" severity="error" [closable]="false">
          <ng-template pTemplate>
            <div class="flex flex-column gap-2">
              <span>{{listError.message}}</span>
              <p-button *ngIf="listError.retryable" label="Reintentar" icon="pi pi-refresh"
                        size="small" [text]="true" (click)="loadMessages()"></p-button>
            </div>
          </ng-template>
        </p-messages>

        <app-message-list *ngIf="!listError"
                          [messages]="messages"
                          [totalRecords]="totalRecords"
                          [rows]="rows"
                          [first]="first"
                          [loading]="listLoading"
                          [selectedUid]="selectedUid"
                          [grouped]="grouped"
                          [conversations]="conversations"
                          (pageChanged)="onPageChanged($event)"
                          (conversationToggled)="onConversationToggled($event)"
                          (messageSelected)="onMessageSelected($event)"></app-message-list>
      </div>
    </section>

    <!-- lectura -->
    <section class="mailbox-panel mailbox-reader">
      <div class="panel-body">
        <p-messages *ngIf="messageError" severity="error" [closable]="false">
          <ng-template pTemplate>
            <div class="flex flex-column gap-2">
              <span>{{messageError.message}}</span>
              <p-button *ngIf="messageError.retryable && selectedUid" label="Reintentar" icon="pi pi-refresh"
                        size="small" [text]="true" (click)="loadMessage(selectedUid!)"></p-button>
            </div>
          </ng-template>
        </p-messages>

        <app-message-view *ngIf="!messageError"
                          [message]="message"
                          [loading]="messageLoading"
                          [bodyDocument]="bodyDocument"
                          [bodyUrl]="bodyUrl"
                          [sourceUrl]="sourceUrl"
                          [allowRemoteImages]="allowRemoteImages"
                          [allowManage]="allowManage"
                      [allowSend]="allowSend"
                          [moveTargets]="folders"
                          (allowRemoteImagesChange)="onAllowRemoteImages()"
                          (toggleSeen)="onToggleSeen()"
                          (toggleFlagged)="onToggleFlagged()"
                          (deleteRequested)="onDeleteRequested()"
                          (moveRequested)="onMoveRequested($event)"
                          (attachmentRequested)="onAttachmentRequested($event)"
                          (composeRequested)="onComposeRequested($event)"></app-message-view>
      </div>
    </section>
  </div>
</p-card>

<app-compose-dialog #composer
                    [mailAccountId]="mailAccountId"
                    [accountName]="account?.name ?? null"
                    [accountAddress]="accountAddress"
                    (sent)="onSent()"></app-compose-dialog>

<app-folders-manager [mailAccountId]="mailAccountId"
                    [visible]="foldersManagerVisible"
                    (visibleChange)="foldersManagerVisible = $event"
                    (subscriptionsChanged)="loadFolders()"></app-folders-manager>

<p-confirmDialog></p-confirmDialog>
